import { FaCode, FaDatabase, FaTools } from 'react-icons/fa';
import './Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      title: 'Languages & Frameworks',
      icon: <FaCode />,
      skills: [
        'JavaScript',
        'TypeScript',
        'Next.js',
        'Node.js',
        'Express.js',
        'React.js',
        'Dart',
        'Flutter',
      ],
    },
    {
      title: 'Databases & Tools',
      icon: <FaDatabase />,
      skills: [
        'MongoDB',
        'PostgreSQL',
        'Highcharts',
        'Material UI',
        'Tailwind CSS',
        'Visual Studio Code',
        'Git',
        'GitHub',
      ],
    },
    {
      title: 'Technologies & Others',
      icon: <FaTools />,
      skills: [
        'REST APIs',
        'Agile methodology',
        'Twilio integration',
        'JWT Authentication',
        'AWS EC2',
        'AWS S3',
        'Application Load Balancer (ALB)',
        'Performance optimization',
      ],
    },
  ];

  return (
    <section id='skills' className='skills'>
      <div className='container'>
        <h2 className='section-title'>Skills & Expertise</h2>

        <div className='skills-grid'>
          {skillCategories.map((category, index) => (
            <div key={index} className='skill-category'>
              <div className='category-header'>
                <div className='category-icon'>{category.icon}</div>
                <h3>{category.title}</h3>
              </div>
              <div className='skills-list'>
                {category.skills.map((skill, skillIndex) => (
                  <span key={skillIndex} className='skill-tag'>
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className='skills-highlight'>
          <div className='highlight-content'>
            <h3>Why Choose Me?</h3>
            <p>
              With expertise in both frontend and backend technologies, I bring
              a comprehensive approach to software development. My experience in
              healthcare technology and community-driven applications
              demonstrates my ability to work on impactful projects that make a
              real difference in people's lives.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
